import { useEffect, useState } from "react";
import { TrackingRequest, usePostTrackingPopPrint } from "../../../../hooks/morning/usePostTrackingPopPrint";
import PrintA4 from "./PrintA4";
import Spinner from "components/Spinner";

const TrackingPrintView = ({
    onClose,
    bl_no,
    filter,
    isAllPrint,
}: {
    onClose: () => void;
    bl_no?: string[];
    filter?: TrackingRequest;
    isAllPrint?: boolean;
}) => {
    const [printA4Pop, setPrintA4Pop] = useState<boolean>(false);
    const [printData, setPrintData] = useState<any>(null);
    const linkPrint = true;

    const { mutate, isPending } = usePostTrackingPopPrint(linkPrint);

    useEffect(() => {
        // 일반 A4 출력
        mutate(getPayload(), {
            onSuccess: data => {
                setPrintData(data);
                setPrintA4Pop(true);
            },
        });
    }, []);

    useEffect(() => {
        document.body.classList.add("modal-open");

        return () => {
            document.body.classList.remove("modal-open");
        };
    }, []);

    const getPayload = (extra: Partial<TrackingRequest> = {}): TrackingRequest => {
        if (!isAllPrint) {
            return {
                chk_bl_no: bl_no ?? [],
                ...extra,
            } as TrackingRequest;
        }

        const { chk_bl_no, ...rest } = {
            ...filter,
            ...extra,
        };
        return rest as TrackingRequest;
    };

    if (isPending) return <Spinner />;

    return (
        <>
            {printA4Pop && (
                <>
                    {printData && printData?.length > 0 ? (
                        <div className="fixed inset-0 z-[200] bg-black bg-opacity-40 flex items-center justify-center">
                            <PrintA4
                                data={printData}
                                onClose={() => {
                                    setPrintA4Pop(false);
                                    // setSelectedCard(null);
                                    onClose();
                                }}
                            />
                        </div>
                    ) : (
                        <div>데이터가 없습니다.</div>
                    )}
                </>
            )}
        </>
    );
};

export default TrackingPrintView;
